import React from "react";
import PayfacPrefixSearchField from "./PayfacPrefixSearchField";
import { usePayfacPrefixMeta } from "./payfacPrefixColumn";

const PayfacPrefixSearchFilter = ({
  searchFieldInput,
  setSearchFieldInput,
  disabled = false,
  visible = true,
  field = "payfacPrefix",
  sx,
}) => {
  const { isSuperAdmin, label } = usePayfacPrefixMeta();
  const shouldRender = isSuperAdmin && !!visible;

  if (!shouldRender) {
    return null;
  }

  return (
    <PayfacPrefixSearchField
      label={label}
      value={searchFieldInput?.[field] || ""}
      onChangeValue={(value) =>
        setSearchFieldInput((state) => ({
          ...state,
          [field]: value,
        }))
      }
      disabled={disabled}
      sx={sx}
    />
  );
};

export default React.memo(PayfacPrefixSearchFilter);
